import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetPDIChecks = createModule({
  base: 'GET_PDI_CHECK',
  apiDetails: {
    ...SERVICE_ENDPOINT.PDI_CHECK,
    url: `${SERVICE_ENDPOINT.PDI_CHECK.url}/list`,
    method: 'get',
  },
  errors: { defaultError: true, customError: '' },
});

const CreatePDICheck = createModule({
  base: 'CREATE_PDI_CHECK',
  apiDetails: { ...SERVICE_ENDPOINT.PDI_CHECK, method: 'put' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const GetPDICheckById = createModule({
  base: 'GET_PDI_CHECK_BY_ID',
  apiDetails: { ...SERVICE_ENDPOINT.PDI_CHECK, method: 'get' },
  errors: { defaultError: true, customError: '' },
});

const CancelPDICheck = createModule({
  base: 'CANCEL_PDI_CHECK',
  apiDetails: { ...SERVICE_ENDPOINT.PDI_CHECK, method: 'put', url: `${SERVICE_ENDPOINT.PDI_CHECK.url}/status` },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const GetPDICheckWorkflows = createModule(
  { base: 'GET_PDI_CHECK_WORKFLOWS', apiDetails: SERVICE_ENDPOINT.WORKFLOWS },
);

const UpdatePDICheckStatus = createModule({
  base: 'UPDATE_CHECK_PDI_STATUS',
  apiDetails: { url: `${SERVICE_ENDPOINT.PDI_CHECK.url}/status`, method: 'put' },
  enableNotification: true,
  customNotificationSuccessMessage: 'PDI status updated successfully',
});

const UpdatePDICheckWorkflowStep = createModule({
  base: 'UPDATE_PDI_CHECK_WORKFLOW_STEP',
  apiDetails: {
    url: `${SERVICE_ENDPOINT.PDI_CHECK.url}/workflow`,
    method: 'post',
  },
  enableNotification: true,
});

export { GetPDIChecks, CreatePDICheck, GetPDICheckById, CancelPDICheck, UpdatePDICheckWorkflowStep, GetPDICheckWorkflows, UpdatePDICheckStatus };
